import { render, staticRenderFns } from "./DeleteWidget.vue?vue&type=template&id=51d7dbd1"
import script from "./DeleteWidget.vue?vue&type=script&lang=js"
export * from "./DeleteWidget.vue?vue&type=script&lang=js"
import style0 from "./DeleteWidget.vue?vue&type=style&index=0&id=51d7dbd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports